import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: COLOR_PURPLE,
  },
  mainContentBox: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 6,
    boxShadow: '0px 3px 6px #00000029',
  },
  mainFeaturesBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '50px',
  },
  titleFeatures: {
    color: COLOR_PURPLE,
    fontSize: 18,
    padding: theme.spacing(1.5, 0),
    fontWeight: 'bold',
  },
}));
